import { CustomRegistry } from "@nemuru-eng/js-api-client";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../../shared/config";

export const LOAN_SUMMARY_AND_ADJUST_STEP_NAMES = {
  RISK_ANALYSIS_OPT_INS: "RISK_ANALYSIS_OPT_INS",
  SUMMARY_AND_ADJUST: "SUMMARY_AND_ADJUST",
  ADD_CO_BORROWER_TO_LOAN: "ADD_CO_BORROWER_TO_LOAN",
};

export const CARD_SUMMARY_STEP_NAMES = {
  RISK_ANALYSIS_OPT_INS: "RISK_ANALYSIS_OPT_INS",
  CARD_SUMMARY: "CARD_SUMMARY",
};

export const getLoanTimer = {
  GET_LOAN_CASH_IN_CASH_OUT_METHOD_TIMEOUT_MILLISECONDS: 2000,
  GET_LOAN_SELECTED_LOAN_APPLICATION_TIMEOUT_MILLISECONDS: 2000,
  GET_LOAN_SELECTED_LOAN_APPLICATION_MAX_TIMEOUT_MILLISECONDS: 90000,
};

export const SUMMARY_AND_ADJUST_LOAN_OPTINS_TYPES_LIST = [
  { commercial: "commercial" },
  {
    application_data_consents: "application_data_consents",
  },
  { third_party_commercial: "third_party_commercial" },
  {
    loan_position_in_lender: "loan_position_in_lender",
  },
];

export const RISK_ANALYSIS_OPTINS_TYPES_LIST = [
  { lender_specific: "lender_specific" },
];

export const LENDER_SPECIFIC_OPTINS_LIST = [
  { lender_specific: "lender_specific" },
];

export const REGISTRIES_WITH_ORDERING_NEEDED = [
  CustomRegistry.CAIXABANK,
  CustomRegistry.FACILITEA,
  CustomRegistry.TESLA,
];

export const PRODUCT_TYPES = {
  CREDIT_LINE: "credit_line",
  CONSUMER_LOAN: "consumer_loan",
  AUTO_LOAN: "auto_loan",
  CARD: "card",
};

export const ALLOWED_PRODUCTS_FOR_LOAN = [
  PRODUCT_TYPES.CONSUMER_LOAN,
  PRODUCT_TYPES.AUTO_LOAN,
];

export const ALLOWED_PRODUCTS_FOR_CARD = [PRODUCT_TYPES.CARD];

export const ALLOWED_PRODUCTS_FOR_CREDIT_LINE = [PRODUCT_TYPES.CREDIT_LINE];

export const NIE_FIRST_LETTER_VALIDATOR = /^[XYZxyz]$/;
export const PHONE_NUMBER_PREFIX = "+34";

export const PARTICIPANT_RELATION = {
  SPOUSE: "spouse",
  SIBLING: "sibling",
  PARENT: "parent",
  SON: "son",
  REST_OF_FAMILY: "rest_of_family",
  OTHER: "other",
};
export const PARTICIPANT_ALLOWED_ROLES = [
  ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER,
];
